import React from "react";
import { Modal, ModalHeader, ModalFooter } from "reactstrap";

const ConfirmModal = ({ isOpen, toggle, title, subtitle, icon, iconBg, onConfirm, confirmText }) => {
    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalHeader className="pl-4 border-bottom-0" toggle={toggle}>
                <div className="d-flex">
                    <div className="p-3 mr-4" style={{ backgroundColor: iconBg, borderRadius: "8px" }}>
                        <img alt="" src={icon} />
                    </div>
                    <div>
                        <div style={{ color: "#143B5E", fontWeight: 700, fontSize: "18px", lineHeight: "27px" }}>
                            {title}
                        </div>
                        {subtitle && (
                            <div style={{ color: "#5D6F80", fontWeight: 400, fontSize: "14px", lineHeight: "24px" }}>
                                {subtitle}
                            </div>
                        )}
                    </div>
                </div>
            </ModalHeader>
            <ModalFooter style={{ borderTop: 0 }}>
                <button className="izin-tolak-button w-100" onClick={toggle}>
                    Batal
                </button>{" "}
                <button className="btn btn-primary text-capitalize w-100" style={{ fontSize: "14px", fontWeight: 500, lineHeight: "24px" }} onClick={onConfirm}>
                    {confirmText}
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmModal;